import React from 'react';
import Hero from './Hero';
import Drinkers from './Drinkers';
import Shops from './Shops';
import Farmers from './Farmers';
import News from './News';
import Roasters from './Roaster';
import Barista from './Barista';

function Koffieland() {
  return (
    <>
      <Hero />
      <Drinkers />
      <Farmers/>
      <Shops />
      <Barista />
      <Roasters />
      <News />
    </>
  );
}

export default Koffieland;